import { render, staticRenderFns } from "./LegalAtlasModal.vue?vue&type=template&id=596c0cfc&scoped=true&"
import script from "./LegalAtlasModal.vue?vue&type=script&lang=js&"
export * from "./LegalAtlasModal.vue?vue&type=script&lang=js&"
import style0 from "./LegalAtlasModal.vue?vue&type=style&index=0&id=596c0cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c0cfc",
  null
  
)

export default component.exports